import React from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import Dashboard from '../pages/Dashboard';
import TasksList from '../pages/TasksList';
import Formulario from '../pages/Formulario';
import Incidentes from '../pages/Incidentes';
import IncidentDetail from '../pages/IncidentDetail';
import Tad from '../pages/Tad';
import VialidadReportPage from '../pages/VialidadReportPage';
import ContactPortalHome from '../pages/ContactPortalHome';
import ContactLogin from '../pages/ContactLogin';
import ContactRegister from '../pages/ContactRegister';
import ContactActivate from '../pages/ContactActivate';
import ContactResendActivation from '../pages/ContactResendActivation';
import ContactPasswordResetRequest from '../pages/ContactPasswordResetRequest';
import ContactPasswordResetConfirm from '../pages/ContactPasswordResetConfirm';
import ContactTasksList from '../pages/ContactTasksList';
import IframeTaskCreate from '../pages/IframeTaskCreate';
import ContactTaskDetail from '../pages/ContactTaskDetail';
import ContactPrivateRoute from './ContactPrivateRoute';

const NotFound = () => {
  const location = useLocation();
  return (
    <div>
      <h2>❌ 404 - Page Not Found</h2>
      <p>URL: <code>{location.pathname}</code></p>
    </div>
  );
};

function App() {
  return (
    <Router>     
      <Routes>
        <Route path="/" element={<ContactPortalHome />} />
        <Route
          path="/consultas-y-reclamos/create"
          element={<IframeTaskCreate />}
        />
        <Route path="/contactos/login" element={<ContactLogin />} />
        <Route path="/contactos/registrarse" element={<ContactRegister />} />
        <Route path="/contactos/activar" element={<ContactActivate />} />
        <Route path="/contactos/reenviar-activacion" element={<ContactResendActivation />} />
        <Route path="/contactos/recuperar-contrasena" element={<ContactPasswordResetRequest />} />
        <Route path="/contactos/restablecer-contrasena" element={<ContactPasswordResetConfirm />} />
        <Route
          path="/consultas-y-reclamos"
          element={(
            <ContactPrivateRoute>
              <ContactTasksList />
            </ContactPrivateRoute>
          )}
        />
        <Route
          path="/consultas-y-reclamos/:id"
          element={(
            <ContactPrivateRoute>
              <ContactTaskDetail />
            </ContactPrivateRoute>
          )}
        />
        <Route path="/admin/" element={<Dashboard />} /> 
        <Route path="/admin/questions/task/informes-vialidad" element={<VialidadReportPage />} />
        <Route path="/admin/questions/task/formulario_web" element={<Formulario />} />
        <Route path="/admin/questions/task/incidentes" element={<Incidentes />} />
        <Route path="/admin/questions/task/incidentes/list" element={<TasksList />} />
        <Route path="/admin/questions/task/incidentes/:id" element={<IncidentDetail />} />
        <Route path="/admin/questions/task/cau" element={<Tad />} />
        <Route path="*" element={<NotFound />} />
      </Routes>
    </Router>
  );
}

export default App;
